import React from 'react';
import NavBar from '../components/NavBar';
import LessonPlanForm from '../components/LessonPlanForm';
import LessonCreatorSidebar from '../components/LessonCreatorSidebar';
import ProtectedRoute from '../components/ProtectedRoute';
import { useFeedback } from '../contexts/FeedbackContext';
import { useLanguage } from '../contexts/LanguageContext';
import { t } from '../utils/translations';
import styles from './CreateLessonPlan.module.css';
import '../App.css';

function CreateLessonPlanContent() {
  const { openFeedbackPanel } = useFeedback();
  const { language } = useLanguage();

  const handleFeedback = () => {
    openFeedbackPanel('screen', {
      page_id: 'create-lesson-plan/form',
      page_name: 'Create A Lesson Plan',
      page_elements: [
        'Lesson info form',
        'Subject / grade / standard selector',
        'Language selector',
        'Cultural connections',
        'Next button',
      ],
    });
  };

  return (
    <div className={`app-container ${styles.openSansScope}`}>
      <NavBar />
      <div className={styles.page}>
        <div className={styles.mainContent}>
          <LessonCreatorSidebar currentStep="lessonInfo" />
          <div className={styles.mainForm}>
            <LessonPlanForm />
          </div>
        </div>
        <div className={styles.feedbackButtonContainer}>
          <button
            type="button"
            className={styles.feedbackBtn}
            onClick={handleFeedback}
            aria-label={t('feedback', language)}
          >
            <img src="/assets/light_bulb.svg" alt="" className={styles.feedbackBtnIcon} />
            <span>{t('feedback', language)}</span>
          </button>
        </div>
        <div className={styles.bottomStrip} aria-hidden />
      </div>
    </div>
  );
}

function CreateLessonPlan() {
  return (
    <ProtectedRoute>
      <CreateLessonPlanContent />
    </ProtectedRoute>
  );
}

export default CreateLessonPlan;
